<template>
  <div class="flex-container">
    <div class="flex-item" style="padding: 0">
      <div
        id="dynamicHeightDiv"
        class="background-style d-flex justify-center align-center"
      >
        <div
          class="carousel-container"
          @touchstart="handleTouchStart"
          @touchmove="handleTouchMove"
          @touchend="handleTouchEnd"
        >
          <div
            class="carousel-content"
            :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
          >
            <!-- Slide 1 -->
            <div class="carousel-slide">
              <div class="carousel-slide-content carousel-slide-1">
                <div class="mobile-illustration-wrapper">
                  <img
                    src="/images/hero/hero-banner-1-mobile.svg"
                    alt="Hero illustration"
                    class="mobile-illustration"
                  />
                </div>
                <div class="container-xxl">
                  <div class="content-wrapper">
                    <h1 class="content-title">
                      The Only GenAI Teaching Assistant for Digital Making
                    </h1>
                    <h3 class="content-subtitle">
                      AI That Turns Ideas into Hands-On Learning
                    </h3>
                    <p class="content-description">
                      Eddy isn't just about automating lessons—it helps teachers
                      bring digital making and STEM to life with real-world,
                      project-based learning.
                    </p>

                    <button
                      class="button-style"
                      @click="handleCtaClick('build')"
                    >
                      <span>Try Eddy For Free</span>
                      <ArrowCircleIcon
                        color="currentColor"
                        class="button-arrow-icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-slide">
              <div class="carousel-slide-content carousel-slide-2">
                <div class="mobile-illustration-wrapper">
                  <img
                    src="/images/hero/hero-banner-2-mobile.svg"
                    alt="Hero illustration"
                    class="mobile-illustration"
                  />
                </div>
                <div class="container-xxl">
                  <div class="content-wrapper">
                    <h1 class="content-title">Save Time, Teach More</h1>
                    <h3 class="content-subtitle">
                      AI That Builds, So You Can Inspire
                    </h3>
                    <p class="content-description">
                      Instantly create standards-aligned, interactive
                      lessons—customizable, engaging, and designed for hands-on
                      learning.
                    </p>

                    <button
                      class="button-style"
                      @click="handleCtaClick('build')"
                    >
                      <span>Generate Your First Lesson</span>
                      <ArrowCircleIcon
                        color="currentColor"
                        class="button-arrow-icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-slide">
              <div class="carousel-slide-content carousel-slide-3">
                <div class="mobile-illustration-wrapper">
                  <img
                    src="/images/hero/hero-banner-3-mobile.svg"
                    alt="Hero illustration"
                    class="mobile-illustration"
                  />
                </div>
                <div class="container-xxl">
                  <div class="content-wrapper">
                    <h1 class="content-title">AI Meets Hands-On Learning</h1>
                    <h3 class="content-subtitle">
                      Bridge the Gap Between Digital & Physical
                    </h3>
                    <p class="content-description">
                      Eddy combines AI-driven lesson planning with hands-on
                      projects, making STEM and digital making more accessible
                      than ever.
                    </p>

                    <button
                      class="button-style"
                      @click="handleCtaClick('contact-us')"
                    >
                      <span>Contact Us</span>
                      <ArrowCircleIcon
                        color="currentColor"
                        class="button-arrow-icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-slide">
              <div class="carousel-slide-content carousel-slide-4">
                <div class="mobile-illustration-wrapper">
                  <img
                    src="/images/hero/hero-banner-4-mobile.svg"
                    alt="Hero illustration"
                    class="mobile-illustration"
                  />
                </div>
                <div class="container-xxl">
                  <div class="content-wrapper">
                    <h1 class="content-title">
                      Revolutionizing Maker Education with AI
                    </h1>
                    <h3 class="content-subtitle">Teach Smarter, Create More</h3>
                    <p class="content-description">
                      Eddy integrates AI with coding, STEM, and digital
                      making—giving teachers the tools to bring ideas to life
                      effortlessly.
                    </p>

                    <button
                      class="button-style"
                      @click="handleCtaClick('makercart')"
                    >
                      <span>Discover Hands-On Learning</span>
                      <ArrowCircleIcon
                        color="currentColor"
                        class="button-arrow-icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-slide">
              <div class="carousel-slide-content carousel-slide-5">
                <div class="mobile-illustration-wrapper">
                  <img
                    src="/images/hero/hero-banner-5-mobile.svg"
                    alt="Hero illustration"
                    class="mobile-illustration"
                  />
                </div>
                <div class="container-xxl">
                  <div class="content-wrapper">
                    <h1 class="content-title">
                      Eddy + Makercart: The Complete Teaching Toolkit
                    </h1>
                    <h3 class="content-subtitle">
                      AI-Powered Lessons + Hands-On Projects = Real Impact
                    </h3>
                    <p class="content-description">
                      Combine Eddy's smart lessons with Makercart's ready-to-use
                      maker kits for a future-ready classroom.
                    </p>

                    <button
                      class="button-style"
                      @click="handleCtaClick('makercart')"
                    >
                      <span>Get a Quote</span>
                      <ArrowCircleIcon
                        color="currentColor"
                        class="button-arrow-icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Arrows (Desktop) -->
          <button
            class="carousel-nav carousel-nav-left"
            @click="prevSlide"
            aria-label="Previous slide"
          >
            <ChevronLeftIcon color="#003D6A" width="28" height="28" />
          </button>
          <button
            class="carousel-nav carousel-nav-right"
            @click="nextSlide"
            aria-label="Next slide"
          >
            <ChevronRightIcon color="#003D6A" width="28" height="28" />
          </button>

          <!-- Pagination Dots (Desktop) -->
          <div class="carousel-pagination">
            <button
              v-for="(slide, index) in totalSlides"
              :key="index"
              :class="['pagination-dot', { active: currentSlide === index }]"
              @click="goToSlide(index)"
              :aria-label="'Go to slide ' + (index + 1)"
            ></button>
          </div>

          <!-- Mobile Navigation Controls -->
          <div class="mobile-nav-controls">
            <button
              class="mobile-nav-button"
              @click="prevSlide"
              aria-label="Previous slide"
            >
              <ChevronLeftIcon color="#003D6A" width="28" height="28" />
            </button>
            <div class="mobile-pagination">
              <button
                v-for="(slide, index) in totalSlides"
                :key="index"
                :class="[
                  'mobile-pagination-dot',
                  { active: currentSlide === index },
                ]"
                @click="goToSlide(index)"
                :aria-label="'Go to slide ' + (index + 1)"
              ></button>
            </div>
            <button
              class="mobile-nav-button"
              @click="nextSlide"
              aria-label="Next slide"
            >
              <ChevronRightIcon color="#003D6A" width="28" height="28" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";
import {  ChevronLeftIcon, ChevronRightIcon, ArrowCircleIcon } from "../icons";

// State
const currentSlide = ref(0);
const totalSlides = 5;
const isAnimating = ref(false);
const slideInterval = 10000;
let autoplayInterval = null;

// Touch State
const touchStartX = ref(0);
const touchEndX = ref(0);
const minSwipeDistance = 50;

// CSS custom properties for background images to avoid webpack resolution issues
const bgImages = {
  desktop: {
    slide1: "/images/hero/home-banner-1.svg",
    slide2: "/images/hero/home-banner-2.svg",
    slide3: "/images/hero/home-banner-3.svg",
    slide4: "/images/hero/home-banner-4.svg",
    slide5: "/images/hero/home-banner-5.svg",
  },
  mobile: {
    slide1: "/images/hero/hero-banner-1-mobile.svg",
    slide2: "/images/hero/hero-banner-2-mobile.svg",
    slide3: "/images/hero/hero-banner-3-mobile.svg",
    slide4: "/images/hero/hero-banner-4-mobile.svg",
    slide5: "/images/hero/hero-banner-5-mobile.svg",
  },
};
// Methods
const adjustHeight = () => {
  const width = window.innerWidth;
  let height = 0;

  if (width < 480) {
    height = 450;
  } else if (width < 768) {
    height = width * (550 / 1200);
  } else if (width < 1024) {
    height = width * (500 / 1440);
  } else {
    height = width * (460 / 1440);
  }

  const dynamicHeightDiv = document.getElementById("dynamicHeightDiv");
  if (dynamicHeightDiv) {
    dynamicHeightDiv.style.height = height + "px";
    dynamicHeightDiv.style.borderRadius = "0px 0px 35px 35px";
  }
};

const setBackgroundImage = () => {
  const dynamicHeightDiv = document.getElementById("dynamicHeightDiv");
  if (dynamicHeightDiv) {
    dynamicHeightDiv.style.backgroundImage =
      "url('/images/hero/background-landscape.svg')";
    dynamicHeightDiv.style.backgroundSize = "cover";
    dynamicHeightDiv.style.backgroundRepeat = "no-repeat";
    dynamicHeightDiv.style.backgroundPosition = "center center";
  }
};

const goToSlide = (index) => {
  if (isAnimating.value) return;
  isAnimating.value = true;
  currentSlide.value = index;
  resetAutoplay();

  // Reset animation flag after transition completes
  setTimeout(() => {
    isAnimating.value = false;
  }, 500);
};

const nextSlide = () => {
  if (isAnimating.value) return;
  isAnimating.value = true;
  currentSlide.value = (currentSlide.value + 1) % totalSlides;
  resetAutoplay();

  // Reset animation flag after transition completes
  setTimeout(() => {
    isAnimating.value = false;
  }, 500);
};

const prevSlide = () => {
  if (isAnimating.value) return;
  isAnimating.value = true;
  currentSlide.value = (currentSlide.value - 1 + totalSlides) % totalSlides;
  resetAutoplay();

  // Reset animation flag after transition completes
  setTimeout(() => {
    isAnimating.value = false;
  }, 500);
};

const startAutoplay = () => {
  autoplayInterval = setInterval(() => {
    nextSlide();
  }, slideInterval); // Change slide every 5 seconds
};

const resetAutoplay = () => {
  clearInterval(autoplayInterval);
  startAutoplay();
};

const handleTouchStart = (e) => {
  touchStartX.value = e.touches[0].clientX;
  touchEndX.value = e.touches[0].clientX;
};

const handleTouchMove = (e) => {
  touchEndX.value = e.touches[0].clientX;
};

const handleTouchEnd = () => {
  const swipeDistance = touchStartX.value - touchEndX.value;

  if (Math.abs(swipeDistance) > minSwipeDistance) {
    if (swipeDistance > 0) {
      // Swiped left
      nextSlide();
    } else {
      // Swiped right
      prevSlide();
    }
  }
};

// Lifecycle hooks
onMounted(() => {
  adjustHeight();
  setBackgroundImage();
  window.addEventListener("resize", adjustHeight);
  startAutoplay();

  // Set CSS custom properties for desktop and mobile backgrounds
  const root = document.documentElement;
  // Desktop backgrounds
  root.style.setProperty(
    "--slide-1-desktop-bg",
    `url('${bgImages.desktop.slide1}')`
  );
  root.style.setProperty(
    "--slide-2-desktop-bg",
    `url('${bgImages.desktop.slide2}')`
  );
  root.style.setProperty(
    "--slide-3-desktop-bg",
    `url('${bgImages.desktop.slide3}')`
  );
  root.style.setProperty(
    "--slide-4-desktop-bg",
    `url('${bgImages.desktop.slide4}')`
  );
  root.style.setProperty(
    "--slide-5-desktop-bg",
    `url('${bgImages.desktop.slide5}')`
  );
  // Mobile backgrounds
  root.style.setProperty(
    "--slide-1-mobile-bg",
    `url('${bgImages.mobile.slide1}')`
  );
  root.style.setProperty(
    "--slide-2-mobile-bg",
    `url('${bgImages.mobile.slide2}')`
  );
  root.style.setProperty(
    "--slide-3-mobile-bg",
    `url('${bgImages.mobile.slide3}')`
  );
  root.style.setProperty(
    "--slide-4-mobile-bg",
    `url('${bgImages.mobile.slide4}')`
  );
  root.style.setProperty(
    "--slide-5-mobile-bg",
    `url('${bgImages.mobile.slide5}')`
  );
});

const handleCtaClick = (ctaType) => {
  if (ctaType === "contact-us") {
    // Send email to help@eddy4teachers.com
    window.open("mailto:hello@eddy4teachers.com", "_self");
  } else if (ctaType === "build") {
    window.location.href = "#lesson-generation";
  } else if (ctaType === "makercart") {
    window.open("/makercart-studio", "_blank");
  }
};

onBeforeUnmount(() => {
  window.removeEventListener("resize", adjustHeight);
  clearInterval(autoplayInterval);
});
</script>

<style>
.flex-container {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.flex-item {
  flex: 1;
  /* Mirip dengan mengambil seluruh lebar yang tersedia */
  margin-right: 0px !important;
}

.center-text {
  text-align: center;
}

/* Carousel styles */
.carousel-container {
  position: relative;
  width: 100vw;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  /* margin-left: calc(-50vw + 50%); */
}

.carousel-content {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
}

.carousel-slide {
  flex: 0 0 100%;
  height: 100%;
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.carousel-slide-content {
  width: 100vw;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  justify-content: flex-start;
  padding: 0 80px;
  backdrop-filter: blur(50px);
}

/* Desktop slide backgrounds */
.carousel-slide-1 {
  background-image: var(--slide-1-desktop-bg);
}

.carousel-slide-2 {
  background-image: var(--slide-2-desktop-bg);
}

.carousel-slide-3 {
  background-image: var(--slide-3-desktop-bg);
}

.carousel-slide-4 {
  background-image: var(--slide-4-desktop-bg);
}

.carousel-slide-5 {
  background-image: var(--slide-5-desktop-bg);
}

.carousel-slide-content .content-wrapper {
  width: 40%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  color: var(--primary-blue);
}

.content-title {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.1;
  margin: 0;
}

.content-subtitle {
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
  opacity: 0.9;
}

.content-description {
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  opacity: 0.8;
}

.button-style {
  border: 1px solid var(--primary-blue);
  color: var(--primary-blue);
  background-color: white;
  border-radius: 12px;
  padding: 15px 60px;
  width: fit-content;
  font-weight: 600;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.button-arrow-icon {
  flex-shrink: 0;
}

.button-style:hover {
  background-color: var(--primary-blue);
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 61, 106, 0.2);
}

.button-style:active {
  transform: translateY(0);
}

/* Pagination Dots */
.carousel-pagination {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 10;
}

.pagination-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid black;
  background-color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pagination-dot:hover {
  border-color: black;
  transform: scale(1.1);
}

.pagination-dot.active {
  background-color: var(--primary-blue);
  border-color: black;
  transform: scale(1.2);
}

/* Navigation Arrows */
.carousel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  border-radius: 8px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  color: var(--primary-blue);
}

.carousel-nav:hover {
  transform: translateY(-50%) scale(1.1);
}

.carousel-nav:active {
  transform: translateY(-50%) scale(1);
}

.carousel-nav-left {
  left: 15px;
}

.carousel-nav-right {
  right: 15px;
}

.background-style {
  font-family: "League Spartan";
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

/* Mobile illustration wrapper */
.mobile-illustration-wrapper {
  display: none;
}

.mobile-nav-controls {
  display: none;
}

.button-style {
  display: flex;
  align-items: center;
  gap: 8px;
}

.button-arrow-icon {
  flex-shrink: 0;
}

/* Small mobile devices */
@media (max-width: 480px) {
  .carousel-nav,
  .carousel-pagination {
    display: none;
  }

  .mobile-nav-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
  }

  .mobile-nav-button {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: transparent;
    padding: 0;
  }

  .mobile-nav-button:active {
    transform: scale(0.95);
  }

  .mobile-pagination {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 24px;
  }

  .mobile-pagination-dot {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid var(--primary-blue);
    background-color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
  }

  .mobile-pagination-dot:hover {
    transform: scale(1.1);
  }

  .mobile-pagination-dot.active {
    background-color: var(--primary-blue);
    border-color: var(--primary-blue);
    transform: scale(1.2);
  }

  .mobile-illustration-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-top: 16px;
    flex-shrink: 0;
  }

  .mobile-illustration {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  .content-title {
    font-size: var(--fs-xl);
    line-height: 32px;
    font-weight: 700;
  }

  .content-subtitle {
    font-size: var(--fs-medium);
    line-height: 24px;
    font-weight: 500;
    letter-spacing: 0.15px;
  }

  .content-description {
    font-size: var(--fs-medium);
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0.5px;
    display: none;
  }

  .button-style {
    font-size: var(--fs-small);
    line-height: 20px;
    font-weight: 700;
    letter-spacing: 0.1px;
    padding: 10px 16px;
    height: 40px;
    border-radius: 8px;
    width: auto;
    margin: 0 auto;
  }

  .carousel-slide-content {
    padding: 16px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;
  }

  .carousel-slide-1 {
    background-image: none;
    background-color: #d4e4fc;
  }

  .carousel-slide-2 {
    background-image: none;
    background-color: #fce8d4;
  }

  .carousel-slide-3 {
    background-image: none;
    background-color: #d4fcd9;
  }

  .carousel-slide-4 {
    background-image: none;
    background-color: #ffc4df;
  }

  .carousel-slide-5 {
    background-image: none;
    background-color: #e3e4ff;
  }

  .carousel-slide-content .content-wrapper {
    width: 100%;
    gap: 16px;
    justify-content: center;
    text-align: center;
    flex: 1;
  }
}

/* Mobile devices */
@media (min-width: 481px) and (max-width: 767px) {
  .carousel-nav,
  .carousel-pagination {
    display: none;
  }

  .mobile-nav-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
  }

  .mobile-nav-button {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
  }

  .mobile-nav-button:active {
    transform: scale(0.95);
  }

  .mobile-pagination {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 24px;
  }

  .mobile-pagination-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 1px solid var(--primary-blue);
    background-color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
  }

  .mobile-pagination-dot:hover {
    transform: scale(1.1);
  }

  .mobile-pagination-dot.active {
    background-color: var(--primary-blue);
    border-color: var(--primary-blue);
    transform: scale(1.2);
  }

  .mobile-illustration-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-top: 16px;
    flex-shrink: 0;
  }

  .mobile-illustration {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  .content-title {
    font-size: var(--fs-xl);
    line-height: 32px;
    font-weight: 700;
  }

  .content-subtitle {
    font-size: var(--fs-medium);
    line-height: 24px;
    font-weight: 500;
    letter-spacing: 0.15px;
  }

  .content-description {
    display: none;
  }

  .button-style {
    font-size: var(--fs-small);
    line-height: 20px;
    font-weight: 700;
    letter-spacing: 0.1px;
    padding: 10px 16px;
    height: 40px;
    border-radius: 8px;
    width: auto;
    margin: 0 auto;
  }

  .carousel-slide-content {
    padding: 16px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;
  }

  .carousel-slide-1 {
    background-image: none;
    background-color: #d4e4fc;
  }

  .carousel-slide-2 {
    background-image: none;
    background-color: #fce8d4;
  }

  .carousel-slide-3 {
    background-image: none;
    background-color: #d4fcd9;
  }

  .carousel-slide-4 {
    background-image: none;
    background-color: #ffc4df;
  }

  .carousel-slide-5 {
    background-image: none;
    background-color: #e3e4ff;
  }

  .carousel-slide-content .content-wrapper {
    width: 100%;
    gap: 16px;
    justify-content: center;
    text-align: center;
    flex: 1;
    max-width: 272px;
  }
}

/* Tablets */
@media (min-width: 768px) and (max-width: 1024px) {
  .content-title {
    font-size: 2.2rem;
    line-height: 1.1;
  }

  .content-subtitle {
    font-size: 1.4rem;
    line-height: 1.2;
  }

  .content-description {
    font-size: 1rem;
    line-height: 1.5;
  }

  .button-style {
    font-size: 1rem;
    padding: 12px 30px;
  }

  .carousel-slide-content {
    padding: 0 6vw;
  }

  .carousel-slide-content .content-wrapper {
    width: 65%;
  }
}

/* Small laptops */
@media (min-width: 1025px) and (max-width: 1199px) {
  .content-title {
    font-size: 2rem;
    line-height: 1.1;
  }

  .content-subtitle {
    font-size: 1.3rem;
    line-height: 1.2;
  }

  .content-description {
    font-size: 1rem;
    line-height: 1.5;
  }

  .button-style {
    font-size: 1rem;
    padding: 12px 32px;
  }

  .carousel-slide-content {
    padding: 0 60px;
  }

  .carousel-slide-content .content-wrapper {
    width: 55%;
  }
}

/* Medium laptops */
@media (min-width: 1200px) and (max-width: 1366px) {
  .content-title {
    font-size: 2.3rem;
    line-height: 1.1;
  }

  .content-subtitle {
    font-size: 1.5rem;
    line-height: 1.2;
  }

  .content-description {
    font-size: 1.05rem;
    line-height: 1.5;
  }

  .button-style {
    font-size: 1.05rem;
    padding: 12px 35px;
  }

  .carousel-slide-content {
    padding: 0 60px;
  }

  .carousel-slide-content .content-wrapper {
    width: 52%;
  }
}

/* Medium-Large screens */
@media (min-width: 1367px) and (max-width: 1599px) {
  .content-title {
    font-size: 2.8rem;
    line-height: 1.1;
  }

  .content-subtitle {
    font-size: 1.8rem;
    line-height: 1.2;
  }

  .content-description {
    font-size: 1.15rem;
    line-height: 1.5;
  }

  .button-style {
    font-size: 1.1rem;
    padding: 13px 40px;
  }

  .carousel-slide-content {
    padding: 0 70px;
  }

  .carousel-slide-content .content-wrapper {
    width: 48%;
  }
}

/* Large screens */
@media (min-width: 1600px) {
  .content-title {
    font-size: 3.5rem;
    line-height: 1.1;
  }

  .content-subtitle {
    font-size: 2rem;
    line-height: 1.2;
  }

  .content-description {
    font-size: 1.25rem;
    line-height: 1.5;
  }

  .button-style {
    font-size: 1.2rem;
    padding: 15px 50px;
  }

  .carousel-slide-content {
    padding: 0 80px;
  }

  .carousel-slide-content .content-wrapper {
    width: 45%;
  }
}

.box-style {
  background-color: var(--primary-blue);
  display: inline-block;
  border-radius: 12px;
}

.headline-color {
  color: white;
  margin: 0;
}

.font-25 {
  font-size: 2.5em;
}

.font-23 {
  font-size: 2.3em;
}
</style>
